import { Navigate } from 'react-router-dom';

import { InstitutionFuturesProgressStep } from '@/context/progress';
import { RouteConfigProvider } from '@/context/route-config';
import FuturesAppropriatenessTestForm from '@/features/futures/components/appropriateness-test-form';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';
import { isExemptFromAppropriatenessTest } from '@/features/institution/utils';
import { useProfileClientCategorisationTreatment } from '@/hooks/queries/use-profile-client-categorisation-treatment';
import { useProfileInstitutionDetailsMeta } from '@/hooks/queries/use-profile-institution-details';
import LoadingPage from '@/pages/loading';

const InstitutionFuturesAppropriatenessTestPage = () => {
  const {
    isLoading: isLoadingInstitutionDetailsMeta,
    data: { isRegulated },
  } = useProfileInstitutionDetailsMeta();
  const { isLoading: isLoadingClientCategorisationTreatment, data: clientCategorisationTreatment } = useProfileClientCategorisationTreatment();
  const isLoading = isLoadingInstitutionDetailsMeta || isLoadingClientCategorisationTreatment;

  if (isLoading) return <LoadingPage />;

  if (isRegulated && !clientCategorisationTreatment) return <Navigate to="/institution/futures/client-categorisation/treatment" replace />;

  if (isExemptFromAppropriatenessTest(isRegulated, clientCategorisationTreatment)) return <Navigate to="/institution/futures/appropriateness-test/result" replace />;

  return (
    <FuturesAppropriatenessTestLayout step={InstitutionFuturesProgressStep.APPROPRIATENESS_TEST}>
      <RouteConfigProvider
        config={{
          clientCategorisationTreatment: '/institution/futures/client-categorisation/treatment',
          appropriatenessTestResult: '/institution/futures/appropriateness-test/result',
        }}
      >
        <FuturesAppropriatenessTestForm />
      </RouteConfigProvider>
    </FuturesAppropriatenessTestLayout>
  );
};
InstitutionFuturesAppropriatenessTestPage.displayName = 'InstitutionFuturesAppropriatenessTestPage';

export default InstitutionFuturesAppropriatenessTestPage;
